import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { HypotensionPatients } from './HypotensionPatients';
import { Detail, IDetail } from '../Detail';

/**
 * # Hypotension
 *
 * Hypotension을 설명하세요.
 */
export const Hypotension = types
  .model('Hypotension')
  // --------------------------------------------------------------------------
  .props({
    // predict_time: types.optional(types.string, ''), //  저혈압 예측 완료 시간
    // patients: types.optional(types.array(HypotensionPatients), []),
    targetTime: types.optional(types.string, ''),
    stayId: types.optional(types.number, 0), // 환자ID
    hypProb: types.optional(types.string, ''), // 예측 확률
    hypStr: types.maybeNull(types.optional(types.string, '')), // 예측 결과
    detail: types.optional(Detail, {} as IDetail), // 에러 메시지
    hypTf: types.optional(types.number, 0), //  저혈압 예측 결과 (0/1)
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model hypotension --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IHypotension;
      (Object.keys(newProps) as THypotensionKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type THypotension = Instance<typeof Hypotension>;
type THypotensionSnapshot = SnapshotOut<typeof Hypotension>;

export interface IHypotension extends THypotension {}
export type THypotensionKeys = keyof THypotensionSnapshot & string;
export interface IHypotensionSnapshot extends THypotensionSnapshot {}
export const createHypotension = () => types.optional(Hypotension, {} as THypotension);
